function useStyles({ changeColor, value }: { changeColor: boolean; value: boolean }) {
    return {
        container: () => {
            return {
                width: 'max-content',
                borderRadius: '40px',
                padding: '2px',
                height: '40px',
                backgroundColor: 'white',
                '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                    borderRadius: '40px !important',
                    borderColor: 'transparent',
                },
                '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                    borderRadius: '40px !important',
                    borderColor: 'transparent',
                },
                ...(changeColor && value) && {
                    backgroundColor: 'white',
                }
            }
        },
        toggle: {
            padding: '4px 8px',
            borderRadius: '40px',
            fontSize: '14px',
            fontWeight: 'bold',
            '&.MuiToggleButton-root':{
                minWidth: '120px',
                color: 'black'
            },
            '&.Mui-selected': {
                '&.Mui-disabled': {
                    backgroundColor: 'primary.100',
                    color: 'white',
                }
            },
        }
    }
}

export { useStyles }